module.exports = __webpack_public_path__ + "static/img/3104-1.2ee9774a.jpg";